import React from "react";
import Flexbox from "flexbox-react";


const PageHeading = ({ text,description }) => {
  return (
    <Flexbox flexDirection="row"  alignItems="center" className="">
      <Flexbox flexDirection="column">
      <p className="" style={{fontSize:'28px',fontWeight:'600',color:'#2e2e2e',marginBottom:'0px'}}>{text}</p>
      <p className="" style={{fontSize:'14px',fontWeight:'400',color:'#707070',lineHeight:'normal'}}>{description}</p>
      </Flexbox>
       

    </Flexbox>
  );
};

export default PageHeading;
